import React, { useState } from "react";
import {
  GoogleMap,
  Marker,
  MarkerF,
} from "@react-google-maps/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationArrow } from "@fortawesome/free-solid-svg-icons";
import { Col, Row, Spinner } from "react-bootstrap";
import { Label, Input } from "reactstrap";
import PlacesAutocomplete, {
  geocodeByPlaceId,
} from "react-places-autocomplete";
import "./index.css";
import { useGoogleMaps } from "../../hooks/useGoogleMaps";

//Map Initial Center Place
const center = { lat: 6.9271, lng: 79.8612 };

interface MapProps {
  onSaveLocation: (latitude: number, longitude: number, value: string) => void;
}

const Map: React.FC<MapProps> = ({ onSaveLocation }) => {
 const { isLoaded, loadError } = useGoogleMaps();

  const [map, setMap] = useState<google.maps.Map | null>(null);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [selectedPlaceLatitude, setSelectedPlaceLatitude] = useState<{
    formatted_address: string;
  } | null>(null);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [selectedPlaceLongitude, setSelectedPlaceLongitude] = useState<{
    formatted_address: string;
  } | null>(null);

  const [address, setAddress] = useState<string>("");
  const [searchAddress, setSearchAddress] = useState<string>("");
  const [selectedPlace, setSelectedPlace] = useState<{
    lat: number;
    lng: number;
  } | null>(null);

  const [focusedSuggestionIndex, setFocusedSuggestionIndex] =
    useState<number>(-1);

  //Getting Place lat & lng when click on a place

  const handleMapClick = (e: any) => {
    const langLat = {
      lat: e.latLng.lat(),
      lng: e.latLng.lng(),
    };
    setSelectedPlace(langLat);
    setAddress("");
    setSelectedPlaceLatitude({ formatted_address: langLat.lat.toString() });
    setSelectedPlaceLongitude({ formatted_address: langLat.lng.toString() });
    fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${langLat.lat},${langLat.lng}&key=AIzaSyD_zEfLidcypXTaAVeiQVX5PHlrcj6xEpM`
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "OK") {
          const formattedAddress = data.results[0].formatted_address;
          setAddress(formattedAddress);
          onSaveLocation(langLat.lat, langLat.lng, formattedAddress);
        } else {
          console.error("Reverse geocoding failed:", data.status);
        }
      })
      .catch((error) => console.error("Reverse geocoding error:", error));
  };

  const handleAddressChange = (value: string) => {
    setSearchAddress(value);
  };

  // Places choosing from drop down

  const handleSelect = (value: string, placeId: String) => {
    const placeIdString = placeId.toString();
    geocodeByPlaceId(placeIdString)
      .then((results) => {
        if (results && results.length > 0) {
          const selectedPlace = results[0].geometry.location;
          const lat = selectedPlace.lat();
          const lng = selectedPlace.lng();
          setSelectedPlace({ lat, lng });
          setAddress(value);
          onSaveLocation(lat, lng, value);
          setSelectedPlaceLatitude({ formatted_address: lat.toString() });
          setSelectedPlaceLongitude({ formatted_address: lng.toString() });
          map?.panTo({ lat, lng });
        }
      })
      .catch((error) => console.error("Error fetching place details:", error));
  };

  if (loadError) {
    return <div>Error loading Google Maps: {loadError.message}</div>;
  }

  if (!isLoaded) {
    return <div><Spinner />Loading ...</div>;
  }

  //Navigation through sugetions from arrow keys
  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    const suggestions = e.currentTarget.querySelectorAll(".suggestion-item");
    if (e.key === "ArrowDown") {
      setFocusedSuggestionIndex((prevIndex) =>
        Math.min(prevIndex + 1, suggestions.length - 1)
      );
    } else if (e.key === "ArrowUp") {
      setFocusedSuggestionIndex((prevIndex) => Math.max(prevIndex - 1, -1));
    }
  };

  return (
    <div>
      <div>
        <Row>
          <Col lg="3">
            <Label>Search Your Address</Label>
          </Col>
          {/*Places Auto completing in this Input while typing*/}
          <Col lg="8" style={{ position: "relative" }}>
            <PlacesAutocomplete
              value={searchAddress}
              onChange={handleAddressChange}
              onSelect={(value, placeId) => handleSelect(value, placeId)}
            >
              {({ getInputProps, suggestions, getSuggestionItemProps }) => (
                <div
                  className="suggestions-container"
                  onKeyDown={handleKeyDown}
                >
                  <Input
                    {...getInputProps()}
                    placeholder="Search Your Address Here"
                    style={{ width: "100%" }}
                  />
                  {suggestions.map((suggestion, index) => (
                    <div
                      {...getSuggestionItemProps(suggestion, {
                        className: `suggestion-item ${index === focusedSuggestionIndex ? "focused" : ""
                          }`,
                        key: suggestion.placeId,
                      })}
                    >
                      {suggestion.description}
                    </div>
                  ))}
                </div>
              )}
            </PlacesAutocomplete>
          </Col>
          {/* Location Reseting Icon */}
          <Col lg="1">
            <FontAwesomeIcon
              title="Location Reset"
              icon={faLocationArrow}
              className="location-reset-button"
              onClick={() => map?.panTo(center)}
            />
          </Col>
        </Row>
        <br />
        <Row>
          <Col lg="3">
            <Label>Selected Address</Label>
          </Col>
          <Col lg="9">
            <Input value={address} placeholder="Your Selected Address" disabled />
          </Col>
        </Row>
        <br />
      
      </div>
      <br />
      {/*Map Integration*/}
      <GoogleMap
        center={center}
        zoom={15}
        mapContainerStyle={{ width: "100%", height: "45vh" }}
        options={{
          zoomControl: false,
          streetViewControl: false,
          mapTypeControl: false,
          fullscreenControl: false,
        }}
        onClick={handleMapClick}
        onLoad={(map) => setMap(map)}
      >
        <MarkerF position={center} />
        {selectedPlace && <Marker position={selectedPlace} />}
      </GoogleMap>
    </div>
  );
};

export default Map;
